    const  conditionctevt = [
        "Did you take Physics (of 100 Marks) ?",
        "Did you take Math (of 100 Marks) ?",
        "Did you pass with a minimum of second division?"
      ];
      export default conditionctevt;